<template>
    <b-container>
        <b-row style="margin-top:50px">
            <b-col sm="12" style="flex-direction: row">
                <h1>PathLit</h1>
                <h5>Minjae Kwak</h5>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="9">
                <div>
                    <div>
                    <card v-for="article in articles" :search-tags.sync="searchTags" :key="article.id" :title="article.title" :date="article.date.toDate()" :tags="article.tags" :article="article.article">
                    </card></div>

                    <div v-show="articles.length === 0">{{ loading ? "Loading articles..." : "No article to show :(" }}</div>
                </div>
            </b-col>
            <b-col lg="3" class="search">

                <label>
                    <input type="text" v-model="searchKeyword" placeholder="Search PathLit">
                </label>
                <div>
                    <div v-show="searchTags.length === 0">You can also search with tags from below.</div>
                    <div v-show="searchTags.length !== 0">Selected Tags:
                        <div>
                        <div v-for="tag in searchTags" :key="tag" class="tags"  @click="deleteTag(tag)"> {{ "#"+tag }} </div>
                        </div>
                    </div>
                    <hr>
                    <div class="availableTags">
                        <div class="tags" v-for="tag in allTags" :key="tag" @click="searchTags.push(tag);"> {{ "#"+tag }} </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>

    input[type="text"]{
        border:none;
        border-radius:5px;
        padding:5px;
    }

    div .tags{
        font-size:9.5pt;
        text-transform: uppercase;
        display: inline-block;
        margin-top:10px;
        margin-right:10px;
        padding: 3px 10px 3px 10px;
        border-radius:15px;
        cursor:pointer;
    }

    @media(prefers-color-scheme: light) {

        input[type="text"]{
            background-color: #F4F4F4;
        }

        div.tags {
            background-color: #F4F4F4;
        }

        div.tags:hover {
            background-color: #EEEEEE;
        }
    }

    @media(prefers-color-scheme: dark) {

        .search{
            color:#DDDDDD;
        }

        input[type="text"]{
            background-color: #666666;
            color:white;
        }

        input[type="text"]::placeholder{
            color:#BBBBBB;
        }

        div.tags {
            background-color: #444444;
        }

        div.tags:hover {
            background-color: #555555;
        }
    }
</style>

<script>

    import {db} from "../../main";
    import Card from "./Card";

    export default {
        name: "PathLit",
        data: function(){
            return {
                searchKeyword: "",
                searchTags:[],
                allArticles:[],
                searchTagUnion: true,
                loading: true
            }
        },
        components: {Card},

        computed: {
            articles: function(){
                if(this.searchKeyword === "" && this.searchTags.length === 0){
                    return this.allArticles;
                }

                var returnArr = this.allArticles;
                var self = this;

                if (this.searchKeyword !== ""){
                    returnArr = returnArr.filter(function(article){
                        return article.title.toLowerCase().includes(self.searchKeyword.toLowerCase());
                    });
                }

                if (this.searchTags.length !== 0){
                    returnArr = returnArr.filter(function(article){
                        if(self.searchTagUnion){
                            return self.searchTags.every(element => article.tags.includes(element));
                        }else{
                            return article.tags.some(element => self.searchTags.includes(element));
                        }
                    });
                }

                return returnArr;
            },

            allTags: function(){
                let tags = [];
                for(let i = 0; i < this.allArticles.length; i++){
                    // for each article
                    tags.push(...this.allArticles[i].tags.filter(tag => !tags.includes(tag)));
                }

                tags = tags.filter(tag => !this.searchTags.includes(tag));
                return tags.sort((a, b) => a.localeCompare(b));
            }
        },

        methods:{
            deleteTag: function(tag){
                this.searchTags.splice(this.searchTags.indexOf(tag),1);
            }
        },

        created() {
            // fetch articles
            const self = this;
            db.collection("pathLit").where("public", "==", true).orderBy("date", "desc").onSnapshot(function(querySnapshot){
                self.allArticles = [];
                querySnapshot.forEach(function(doc){
                    const data = {
                        id: doc.id,
                        ...doc.data()
                    };
                    self.allArticles.push(data);
                });

                self.loading = false;
            });
        }
    }

</script>